<template>
  <div class="success-process">
    <div class="success-process-info">
      <img :src="successProcessProductImg" class="success-process-info-img" />
      <div>
        <div class="success-info-title">
          <img src="@/assets/images/icons/check-circle.svg">
          <h4>İşlem başarıyla tamamlandı!</h4>
        </div>
        <P class="success-info-text">Ürün kısa bir süre içinde satışa açılacak.</P>
      </div>
      <button type="button" @click="emit('closeSuccessResultBox')">
        <Icons name="Close" color="#4F4F4F" size="sm" />
      </button>
    </div>
    <div class="success-process-button">
      <AppButton secondary title="Ürün Listesine Git" sm @click="goToProductList" />
    </div>
  </div>
</template>

<script setup>
import { AppButton } from '@n11/so-ui-components';

defineProps({
  successProcessProductImg: {
    type: String,
    required: false,
    default: '',
  },
});

const emit = defineEmits(['closeSuccessResultBox'])

const goToProductList = () => {
  window.location.href = '/selleroffice/v2/product/products';
};

</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.success-process {
  position: fixed;
  top: 84px;
  z-index: 99999;
  right: 60px;
  background-color: $colorN00;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.20);
  border-radius: 6px;

  &-info {
    padding: 16px;
    border-bottom: 0.5px solid $colorN30;
    display: flex;
    align-items: flex-start;
    gap: 16px;

    &-img {
      width: 56px;
      height: 80px;
      object-fit: contain;
      border-radius: 4px;
      outline: 1px solid $colorN30;
    }

    .success-info-title {
      display: flex;
      align-items: center;
      gap: 12px;
      color: $colorM50;
      font-size: 13px;
      font-weight: 700;
      padding: 16px 0 10px;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .success-info-text {
      font-size: 13px;
      margin-bottom: 16px;
    }
  }

  &-button {
    padding: 16px;
  }
}
</style>